import { css } from '@emotion/core';
import { useIntl, Link } from 'gatsby-plugin-intl';
import React from 'react';
import { Desktop, Tablet } from '../../constants/responsive';
import Img from 'gatsby-image';
import { graphql, useStaticQuery } from 'gatsby';
const ProductEntry = ({ name, logoWidthList = [0, 0, 0] }) => {
  const intl = useIntl();
  // const data = useStaticQuery(graphql`
  //   query {
  //     SG: file(relativePath: { eq: "asset-allocation/SmartGlobal.png" }) {
  //       childImageSharp {
  //         fluid(maxWidth: 1200) {
  //           ...GatsbyImageSharpFluid_noBase64
  //         }
  //       }
  //     }
  //     SGU: file(
  //       relativePath: { eq: "asset-allocation/SmartGlobalUltimax.png" }
  //     ) {
  //       childImageSharp {
  //         fluid(maxWidth: 1200) {
  //           ...GatsbyImageSharpFluid_noBase64
  //         }
  //       }
  //     }
  //   }
  // `);
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        ${Tablet} {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        ${Desktop} {
          display: flex;
          flex-direction: ${name === 'SG' ? 'row-reverse' : 'row'};
          align-items: flex-start;
        }
      `}
    >
      {/* 图 */}
      <div
        css={css`
          width: 100%;
          width: 505px;
          ${Tablet} {
            width: 505px;
          }
          ${Desktop} {
            width: 505px;
          }
        `}
      >
        <div
          css={css`
            background: url('/product/${name}.png') center no-repeat;
            background-size: contain;
            // width: 100%;
            // height: 784px;
            display: flex;
            flex:1;
            position: relative;
            color: #333333;
            margin: 0 auto;
            width:315px;
            height: 213px;
            ${Tablet} {
              height: 355px;
            }
            ${Desktop} {
              height: 355px;
            }
          `}
        >
        </div>
        {/* <Img
          css={css`
            width: ${name === 'SG' ? '135%' : '148%'};
            transform: translate(-15%, 0);
            ${Tablet} {
              width: 505px;
              transform: translate(0, 0);
            }
            ${Desktop} {
              width: 505px;
              transform: translate(0px, 0px);
            }
          `}
          fluid={data[name].childImageSharp.fluid}
          imgStyle={{ objectFit: 'fill' }}
          loading='eager'
        /> */}
      </div>
      {/* 空白 width */}
      <div
        css={css`
          width: 0;
          ${Tablet} {
            width: 0;
          }
          ${Desktop} {
            width: 69px;
          }
        `}
      ></div>
      {/* 字 */}
      <div
        css={css`
          text-align: center;
          display: flex;
          align-items: center;
          flex-direction: column;
          ${Tablet} {
            text-align: center;
            display: flex;
            align-items: center;
            flex-direction: column;
          }
          ${Desktop} {
            text-align: left;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
          }
        `}
      >
        <div
          css={css`
            margin-top: 69px;
            ${Tablet} {
              // margin-top: 33px;
            }
            ${Desktop} {
              // margin-top: 124px;
            }
          `}
        >
          <img
            css={css`
              display: ${name === 'SG' ? 'block' : 'none'};
              width: ${logoWidthList[0]}px;
              ${Tablet} {
                width: ${logoWidthList[1]}px;
              }
              ${Desktop} {
                display: block;
                width: ${logoWidthList[2]}px;
              }
            `}
            src={`/product/asset-allocation/${name}-Logo-${intl.locale}.png`}
          />
          {name !== 'SG' && (
            <img
              css={css`
                width: ${logoWidthList[0]}px;
                ${Tablet} {
                  display: block;
                  width: ${logoWidthList[1]}px;
                }
                ${Desktop} {
                  display: none;
                }
              `}
              src={`/product/asset-allocation/${name}-Logo-ipad-${intl.locale}.png`}
            />
          )}
        </div>
        <div
          css={css`
            color: #161616;
            font-weight: normal;
            font-size: 16px;
            width: 316px;
            line-height: 1.38;
            margin-top: 10px;
            ${Tablet} {
              font-size: 18px;
              line-height: 1.11;
              width: 590px;
              margin-top: 10px;
            }
            ${Desktop} {
              font-size: 20px;
              line-height: 1.75;
              width: 594px;
              margin-top: 13px;
            }
          `}
        >
          {intl.formatMessage({
            id: `individuals.longTerm-assetAllocation.product-${name}.description`,
          })}
        </div>
        <div
          css={css`
            margin-top: 20px;
            display: flex;
            ${Tablet} {
              margin-top: 20px;
              display: flex;
            }
            ${Desktop} {
              margin-top: 23px;
              display: flex;
            }
          `}
        >
        </div>
      </div>
    </div>
  );
};
export default ProductEntry;
